// libraries
import React from 'react'

export default function MaskSvg() {
    return (
        <svg width='0' height='0' viewBox='0 0 892 554' className='hidden'>

            <defs>
                <clipPath id='shapeMask' clipPathUnits='objectBoundingBox' transform='scale(0.0011210762331839 0.001805054)'>
                    <path d='M7.25249 33.3005C8.56115 15.0752 24.0941 1.37484 42.3504 2.13748C107.99 4.87956 258.86 10.5523 364.579 9.65957C467.86 8.78748 525.638 2.54397 628.907 0.797687C702.23 -0.442188 804.776 0.0379056 858.019 0.419948C877.286 0.558195 892.501 16.6615 891.713 35.9128C888.963 103.11 883.616 252.312 885.491 357.215C886.388 407.385 889.447 475.974 891.441 517.153C892.379 536.525 877.05 552.827 857.656 552.921C810.921 553.147 727.75 553.396 667.604 552.715C579.473 551.717 530.105 548.558 441.973 547.604C311.369 546.19 124.11 550.024 46.064 551.832C26.3763 552.287 10.4398 536.035 11.0386 516.351C12.107 481.229 13.2869 427.654 12.142 387.882C10.285 323.369 1.72884 287.57 0.235382 223.048C-1.16223 162.667 3.98335 78.8288 7.25249 33.3005Z' />
                </clipPath>
            </defs>

            <defs>
                <clipPath id='shapeMaskMobile' clipPathUnits='objectBoundingBox' transform='scale(0.0011210762331839 0.001805054)'>
                    <path d='M7.1,32.3C8.4,14.1,24-1.4,42.2-0.6c65.7,0.5,216.5,1.9,322.2,1c103.3-0.9,161.1,1.2,264.3-0.5 c73.3-1.2,175.9-0.8,229.1-0.4c19.3,0.1,34.5,16.2,33.7,35.5c-2.8,67.2-8.1,216.4-6.2,321.3c0.9,50.2,4,118.8,5.9,159.9 c0.9,19.4-14.4,35.7-33.8,35.8c-46.7,0.2-129.7,1.9-189.8,1.2c-88.4-1.7-137.1,1-225.3,0c-130.5,0.4-318.1,0.2-396.3,0.7 c-19.7,0.5-35.8-18.8-35.2-38.5c1.1-35.1,2.2-88.7,1.1-128.5C10.2,322.4,1.6,286.6,0.1,222.1C-1.3,161.7,3.9,77.9,7.1,32.3z'/>
                </clipPath>
            </defs>

            <defs>
                <clipPath id='shapeMaskLow' clipPathUnits='objectBoundingBox' transform='scale(0.0011210762331839 0.001805054)'>
                    <path d='M0,32.9C0,0,0,0,35.1,0c198.6,0,414.4,0,815.6,0.1C882.5,0.1,892.3,0,892,36c-2.2,244.9,0,464,0,505.2 c0,13.3-9.8,12.8-21.2,12.8c-46.7,0-134.1,0-831.9,0c-38.9,0-39-1.5-39-38C4.2,207.9,2.9,108.9,0,32.9z'/>
                </clipPath>
            </defs>
            
        </svg>
    )
}